export const upcomingEngagements = [
  {
    id: 'up-1',
    date: 'October 14, 2026',
    organization: 'Point of Departure',
    role: 'Soloist',
    production: 'Bach: Coffee Cantata',
    location: 'Houston, TX',
    url: 'https://www.pointofdeparturehouston.com/coffeehouse-music-salon-1014',
    status: 'upcoming',
  },
  {
    id: 'up-2',
    date: 'November 1, 2026',
    organization: "St. Paul's United Methodist Church",
    role: 'Soloist',
    production: "Brahms Requiem",
    location: 'Houston, TX',
    url: 'https://www.stpaulshouston.org/events/2026/11/1/requiem-for-all-saints',
    status: 'upcoming',
  },
  {
    id: 'up-3',
    date: 'November 8, 2026',
    organization: 'East Texas Pipe Organ Festival',
    role: 'Soloist',
    production: "Brahms Requiem",
    location: 'Kilgore, TX',
    url: 'https://royperryfoundation.org/2026-festival/',
    status: 'upcoming',
  },
  {
    id: 'up-4',
    date: 'February 14, 19, 21, 26, 28, 2027',
    organization: 'Opera San Jose',
    role: 'Edward Teller (cover)',
    production: 'Doctor Atomic',
    location: 'San Jose, CA',
    url: 'https://www.operasj.org/productions/atomic',
    status: 'upcoming',
  },
];

export const pastEngagements = [
  {
    id: 'past-0a',
    date: 'July 25, 26, 27, 28, 2026',
    organization: 'Opera North',
    role: 'Perchik',
    production: "Fiddler on the Roof",
    location: 'Cornish, NH',
    url: 'https://operanorthnh.org/fiddler/',
    status: 'past',
  },
  {
    id: 'past-0b',
    date: 'July 12, 15, 17, 2026',
    organization: 'Opera North',
    role: 'Crony / Dandy',
    production: 'The Ballad of Baby Doe',
    location: 'Cornish, NH',
    url: 'https://operanorthnh.org/baby-doe/',
    status: 'past',
  },
  {
    id: 'past-1',
    date: 'June 26, 28, July 1, 2026',
    organization: 'Opera North',
    role: 'Dandini (Cover)',
    production: 'La Cenerentola',
    location: 'Cornish, NH',
    url: 'https://operanorthnh.org/cenerentola/',
    status: 'past',
  },
  {
    id: 'past-2',
    date: 'May 14, 16, 2026',
    organization: 'HOPERA HTX',
    role: 'Gianluca (Guglielmo)',
    production: 'Cozy (Cos\u00ec Fan Tutte)',
    location: 'Houston, TX',
    url: 'https://hoperahtx.com/cozy/',
    status: 'past',
  },
  {
    id: 'past-3',
    date: 'March 5, 2026',
    organization: 'Contempo Studios',
    role: 'Recital',
    production: 'Lenten Recital Series',
    location: 'Houston, TX',
    url: 'https://www.stpaulshouston.org/events/2026/2/19/2026-lenten-recital-series-mercury-chamber-orchestra-7w7t4-8l6c5',
    status: 'past',
  },
  {
    id: 'past-4',
    date: 'February 7, 2026',
    organization: 'Apollo Chamber Players',
    role: 'Soloist',
    production: "Roumain: And Still We Crossed (world premiere)",
    location: 'Houston, TX',
    url: 'https://www.apollochamberplayers.org/empower.html',
    status: 'past',
  },
  {
    id: 'past-5',
    date: 'January 10, 2026',
    organization: 'Metropolitan Opera Laffont Competition',
    role: 'District Round',
    production: '',
    location: 'Charlotte, NC',
    url: 'https://metcompetitionnc.org/',
    status: 'past',
  },
  {
    id: 'past-6',
    date: 'December 14, 2025',
    organization: 'Brazosport Symphony Orchestra',
    role: 'Soloist',
    production: "Handel: Messiah",
    location: 'Brazosport, TX',
    url: 'https://bcfas.org/event/handels-messiah-concert/',
    status: 'past',
  },
  {
    id: 'past-7',
    date: 'December 13, 2025',
    organization: 'Bach Society Houston',
    role: 'Soloist / Ensemble',
    production: "Bach: Christmas Oratorio",
    location: 'Houston, TX',
    url: 'https://www.simpletix.com/e/bach-s-christmas-oratorio-and-magnificat-tickets-245577',
    status: 'past',
  },
  {
    id: 'past-8',
    date: 'April 5, 2025',
    organization: 'Symphony of Southeast Texas',
    role: 'Soloist',
    production: "Beethoven: Symphony No. 9",
    location: 'Beaumont, TX',
    url: 'https://sost.org/concert/ode-to-joy/',
    status: 'past',
  },
  {
    id: 'past-9',
    date: 'January 24, 25, 26, 2025',
    organization: 'Nashville Opera',
    role: 'Boatswain',
    production: 'HMS Pinafore',
    location: 'Nashville, TN',
    url: '',
    status: 'past',
  },
];